'use strict';

var breakpoints = {
    small: 544,
    medium: 768,
    large: 992,
    extraLarge: 1200,
    extraExtraLarge: 1440
};

module.exports = {
    values: breakpoints
};
